import { useEffect } from 'react';
import { Outlet, createRootRoute, useRouterState } from '@tanstack/react-router';

function RootShell() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    // Tag <body> with the current top-level route so global.css can apply
    // per-route desktop tweaks (e.g. wider column for /graph).
    const slug =
      pathname === '/' ? 'landing' : pathname.replace(/^\//, '').split('/')[0] || 'landing';
    document.body.dataset.route = slug;
  }, [pathname]);

  return <Outlet />;
}

export const Route = createRootRoute({
  component: RootShell,
});
